import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreService } from '../../../../services/core.service';

@Component({
  selector: 'app-branding',
  standalone: true,
  imports: [RouterModule],
  // Sidebar home/logo automation id 19/10/2026 DW
  // Logo lives in sidebar top (no topbar) 28/10/2026 DW
  template: `
    <div class="branding sd-sidebar-branding d-flex align-items-center justify-content-center">
      <a id="sidebar-home-link" [routerLink]="['/']" class="d-flex">
        <img
          src="./assets/images/logos/suredebit-setup-logo.png"
          class="align-middle m-2"
          style="height: 65px; max-width: 100%; object-fit: contain;"
          alt="SureDebit Setup"
        />
      </a>
    </div>
  `,
})
export class BrandingComponent {
  options = this.settings.getOptions();

  constructor(private settings: CoreService) {}
}
